module.exports = __webpack_public_path__ + "static/img/VC.42912e3a.svg";